export class Customer {
    social_reason!: string;
    customer_sector!: string;
    customer_city!: string;
    customer_class!: string;
}
